import { InputHTMLAttributes , useState , useEffect } from 'react';
import cn from 'classnames';
import { SearchIcon, CloseIcon } from '../../custom-icons'
import {API_ENDPOINT, APP_URL,LIMIT} from 'components/config/Common'

import Autocomplete from "./Autocomplete.tsx";

export interface Props extends InputHTMLAttributes<HTMLInputElement> {
  className?: string;
  label: string;
  variant?: 'minimal' | 'normal' | 'with-shadow' | 'flat';
  onSubmit: (e: any) => void;
  onClearSearch: (e: any) => void;
}

const classes = {
  normal:
    'bg-light ltr:pl-6 rtl:pr-6 ltr:pr-14 rtl:pl-14 ltr:rounded-tr-none rtl:rounded-tl-none ltr:rounded-br-none rtl:rounded-bl-none  border ltr:border-r-0 rtl:border-l-0 border-transparent focus:border-accent',
  minimal:
    'search-minimal bg-light rtl:pr-10 ltr:pr-4 rtl:pl-4 ltr:md:pl-14 rtl:md:pr-14 border border-accent ring-accent focus:border-accent focus:bg-gray-100',
  flat: 'bg-white ltr:pl-10 rtl:pr-10 ltr:pr-4 rtl:pl-4 ltr:md:pl-14 rtl:md:pr-14 border-0',
  'with-shadow':
    'search-with-shadow bg-light ltr:pl-10 rtl:pr-10 ltr:pr-12 rtl:pl-12 ltr:md:pl-14 rtl:md:pr-14 focus:bg-light border-0',
};

const SearchBox: React.FC<Props> = ({
  className,
  label,
  onSubmit,
  onClearSearch,
  onChange,
  variant = 'minimal',
  value,
  ...rest
}) => {
  //const [value1, setValue1] = useState("");
  const [items, setItems] = useState([]);
  const [searchdata, setSearchdata] = useState([]);
  const [searchgroupdata, setSearchgroupdata] = useState([]);

    const [val, setVal] = useState("");

  //query rest countries api and set the countries list
  useEffect(() => {
    fetchData();
  }, [value]);

   async function fetchData() {
      if(value && value != ''){
        fetch(`${API_ENDPOINT}/get_search_autocomplete?serachval=${value}`,{
        method: 'GET',
        headers : {        
          'Content-Type': 'application/json',
          'Accept': 'application/json', 
        }
      }).then(function (response) {
          return response.json();
      }).then( (result)=> {
        //console.log('slider======',result)
     
        if(result.status === 1){
          setSearchdata(result?.data);
          setSearchgroupdata(result?.groupdata);
        }
      })
    }else{
        setSearchdata([]);
          setSearchgroupdata([]);
    }
    
    }



  useEffect(() => {
    //if there is no value, return the countries list.
    if (!val) {
      setItems(searchdata);
      return;
    }

    //if the val changes, we filter items so that it can be filtered. and set it as new state
    const newItems = searchdata
      .filter((p) => p.toLowerCase().includes(val.toLowerCase()))
      .sort();
    setItems(newItems);
  }, [searchdata, val ]);

 
  return (
    <form onSubmit={onSubmit} className={cn('w-full flex justify-center items-center', className)}>
      <div
        className={cn('relative flex rounded md:rounded w-full ', {
          'h-14 shadow-900': variant === 'normal',
          'h-11 md:h-12': variant === 'minimal',
          'h-auto !rounded-none': variant === 'flat',
          'h-16 shadow-downfall': variant === 'with-shadow',
        })}
      >
        <label htmlFor={label} className="sr-only">
          {label}
        </label>
        <Autocomplete value={value} onClearSearch={onClearSearch} onChange={onChange} items={items} searchgroupdata={searchgroupdata} label={label} variant={variant} classes={classes} />
        
        {value && (
          <button
            type="button"
            onClick={onClearSearch}
            className={cn(
              'absolute flex h-full w-10 cursor-pointer items-center justify-center text-body transition-colors duration-200 hover:text-accent-hover focus:text-accent-hover focus:outline-none md:w-14',
              {
                'ltr:right-36 rtl:left-36': variant === 'normal',
                'ltr:right-0 rtl:left-0': variant !== 'normal',
              }
            )}
            aria-label="Search"
          >
            <span className="sr-only">close</span>
            <CloseIcon className="h-3.5 w-3.5 md:h-3 md:w-3" />
          </button>
        )}

        {variant === 'normal' ? (
          <button aria-label="Search" className="flex h-full min-w-[143px] items-center justify-center rounded-lg bg-accent px-8 font-semibold text-light transition-colors duration-200 hover:bg-accent-hover focus:bg-accent-hover focus:outline-none ltr:rounded-tl-none ltr:rounded-bl-none rtl:rounded-tr-none rtl:rounded-br-none">
            <SearchIcon className="h-4 w-4 ltr:mr-2.5 rtl:ml-2.5" />
          </button>
        ) : (
          <button aria-label="Search" className="absolute flex h-full w-10 items-center justify-center text-body transition-colors duration-200 hover:text-accent-hover focus:text-accent-hover focus:outline-none ltr:left-0 rtl:right-0 md:w-14">
            <span className="sr-only"></span>
            <SearchIcon className="h-4 w-4" />
          </button>
        )}
      </div>
    </form>
  );
};

export default SearchBox;
